module.exports = __webpack_public_path__ + "static/media/icon_phone.75341569.svg";